import { useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useBreadcrumbLabels } from '../components/BreadcrumbLabelsContext.js';
import { buildAppBreadcrumbs } from '../components/build-app-breadcrumbs.js';
import { PUBLIC_PATHNAMES } from '../lib/public-pathnames.js';

const APP_NAME = 'Nudool';
const HOME_PATHNAMES = new Set(['/', ...PUBLIC_PATHNAMES]);

/** Keeps `document.title` in sync with the current page's breadcrumb label, same trail `AppBreadcrumbs` renders. */
export function useDocumentTitle(): void {
  const pathname = useRouterState({ select: (routerState) => routerState.location.pathname });
  const { labelsById } = useBreadcrumbLabels();

  useEffect(() => {
    if (HOME_PATHNAMES.has(pathname)) {
      document.title = APP_NAME;
      return;
    }

    const crumbs = buildAppBreadcrumbs(pathname, labelsById);
    const lastCrumb = crumbs.at(-1);
    if (!lastCrumb) {
      document.title = APP_NAME;
      return;
    }

    const pageLabel = lastCrumb.singular
      ? `${lastCrumb.label} ${lastCrumb.singular}`
      : lastCrumb.label;
    document.title = `${pageLabel} | ${APP_NAME}`;
  }, [pathname, labelsById]);
}
